export default __webpack_public_path__ + "static/media/13_mobility_flows.8d99bbdf.jpg";